export const TOOL_TASK = 'set-account-status';
export const TOOL_TITLE = 'Set Account Status';
export const TOOL_PROGRESS_LABEL = 'Bulk account status updating progress...';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once updating account status finishes';
export const FILE_NAME = 'Set-account-status-report';
export const FILE_HEADERS = {
    accountId: 'Account Id',
    accountName: 'Account Name',
    oldStatus: 'Old Status',
    newStatus: 'New Status',
    actionStatus: 'Action Status',
};
